import { render } from "./tw-splitbutton.vue?vue&type=template&id=edda96a4"
import script from "./tw-splitbutton.vue?vue&type=script&lang=js"
export * from "./tw-splitbutton.vue?vue&type=script&lang=js"
script.render = render

export default script